import { addSetPrefix } from '@/services/utils.js';
import ph from '@/icons/ph/ph.json';

export default Object.fromEntries(
    Object.entries(ph).map(([key, value]) => [key, addSetPrefix(value)])
);
